// extracted by mini-css-extract-plugin
module.exports = {"GroupInput":"_2uoXCCnNPEEyETN_ncuZUc"};